import type { TourConfig } from './types';

export const leadsTour: TourConfig = {
  id: 'leads-page',
  name: 'Leads Tour',
  description: 'Learn how to manage your leads',
  requiredPath: '/dashboard/leads',
  steps: [
    {
      element: '[data-tour="leads-header"]',
      popover: {
        title: 'Leads Management',
        description:
          'This is where you manage all your leads. Track prospects from first contact to conversion.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: '[data-tour="leads-add-button"]',
      popover: {
        title: 'Add New Lead',
        description:
          'Click here to add a new lead. Capture their contact info and source.',
        side: 'bottom',
        align: 'end',
      },
    },
    {
      element: '[data-tour="leads-search"]',
      popover: {
        title: 'Search Leads',
        description:
          'Quickly find leads by searching their name, phone, or email.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: '[data-tour="leads-status-filter"]',
      popover: {
        title: 'Filter by Status',
        description:
          'Filter leads by their current status: New, Contacted, Qualified, Converted, or Lost.',
        side: 'bottom',
        align: 'center',
      },
    },
    {
      element: '[data-tour="leads-table"]',
      popover: {
        title: 'Lead List',
        description:
          'View all your leads here. Click on status to update it inline, or use the actions menu for more options.',
        side: 'top',
        align: 'center',
      },
    },
  ],
};
